import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from '@tanstack/react-router';
import { createOutlookDialogLogout } from 'src/features/plugins/outlook/components/auth.utils';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';

export default function AuthSetupLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth0();
  const router = {
    push: (href: string) => navigate({ to: href }),
    replace: (href: string) => navigate({ to: href, replace: true }),
    back: () => window.history.back(),
  };
  return (
    <AuthProvider
      redirectPrefix="/plugins/outlook"
      logoutOverride={createOutlookDialogLogout(isAuthenticated, logout, router)}
    >
      {children}
    </AuthProvider>
  );
}
